import { useState, useEffect } from 'react';
import { useCooperativeId } from 'hooks';
import { OrganizationModel } from 'models';
import services from 'services';
import { toDate } from 'utils';

import { InvestorHomeDetails } from 'components';

interface LocalState {
  periodEndingDate: Date | null;
  loading: boolean;
  error: boolean;
}

const InvestorHome = () => {
  const coopId = useCooperativeId();
  const [state, setState] = useState<LocalState>({
    periodEndingDate: null,
    loading: false,
    error: true,
  });

  useEffect(() => {
    (async function () {
      try {
        setState((prevState) => ({
          ...prevState,
          loading: true,
          error: false,
        }));

        const organization: OrganizationModel = (
          await services.get(`/api/portfolios/${coopId}/organization`)
        ).data.Data;

        setState((prevState) => ({
          ...prevState,
          periodEndingDate: toDate(organization.PeriodEndingDate),
          loading: false,
        }));
      } catch (err) {
        console.error(err);

        setState((prevState) => ({
          ...prevState,
          loading: false,
          error: true,
        }));
      }
    })();
  }, [coopId]);

  return <InvestorHomeDetails {...state} />;
};

export default InvestorHome;
